import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TransactionNatureForm, {
  TransactionNatureFormFields,
} from '../../components/TransactionNature/TransactionNatureForm';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';

export default function TransactionNaturesEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [formFields, setFormFields] = useState<TransactionNatureFormFields>(
    null as unknown as TransactionNatureFormFields
  );
  const [formErrors, setFormErrors] = useState({});

  async function getTransactionNature() {
    if (organization && id) {
      const response = await api.get(
        `organizations/${organization.id}/transaction-natures/${id}`
      );

      setFormFields({
        name: response.data.name,
        description: response.data.description,
      });
      setIsLoading(false);
    }
  }

  const onSubmit = async (data: TransactionNatureFormFields) => {
    try {
      await api.put(
        `organizations/${organization.id}/transaction-natures/${id}`,
        data
      );

      navigate('/transaction-natures');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  useEffect(() => {
    getTransactionNature();
  }, [organization, id]);

  return (
    <TransactionNatureForm
      isLoading={isLoading}
      title={`Editar Natureza da Transação ${id}`}
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
